<script setup>
import AppButton from '../../atoms/app/AppButton';
import AppButtonGroup from '../../molecules/app/AppButtonGroup';
import LayoutModal from '../../layouts/LayoutModal';
import {
    useModalStore,
} from '../../../stores/modal-store';

const modal = useModalStore();

const props = defineProps({
    eventId: {
        type: String,
        default: Date.now().toString(),
    },
    closeAction: {
        type: Function,
        default: null,
    },
});

const buttonAction = () => props.closeAction?.() ?? modal.hide();

</script>

<template>
    <LayoutModal class="c-modalApiError">
        <template #headline>
            Sorry!
        </template>
        <p data-qa="error">
            Es ist ein Fehler aufgetreten und wir sind bereits dran das Problem zu beheben
            - bitte versuch es später noch einmal.
        </p>
        <template #actions>
            <AppButtonGroup>
                <AppButton
                    data-qa="confirm"
                    @click="buttonAction"
                >
                    Nochmal versuchen
                </AppButton>
            </AppButtonGroup>
        </template>
    </LayoutModal>
</template>
